import styles from "./States.module.css";

export function Spinner({ label = "Cargando" }: { label?: string }) {
  return (
    <div className={styles.center} role="status">
      <span className={styles.spinner} aria-hidden="true" />
      <span className="muted">{label}…</span>
    </div>
  );
}

/** Esqueleto de grilla de portadas que reserva espacio exacto 2:3 y evita CLS durante la carga. */
export function PosterGridSkeleton({ count = 12, label = "Cargando catálogo" }: { count?: number; label?: string }) {
  return (
    <div role="status" aria-label={label}>
      <div className="grid">
        {Array.from({ length: count }, (_, i) => (
          <div key={i} className={styles.skeletonCard} aria-hidden="true">
            <div className={styles.skeletonCover} />
            <div className={styles.skeletonBody}>
              <div className={styles.skeletonLine} />
              <div className={styles.skeletonLineShort} />
            </div>
          </div>
        ))}
      </div>
      <span className="visually-hidden">{label}…</span>
    </div>
  );
}

/** Esqueleto de la ficha de detalle para evitar saltos de layout (CLS). */
export function DetailSkeleton() {
  return (
    <div className="page" role="status" aria-label="Cargando ficha del anime">
      <div className={styles.detailSkeletonHero} aria-hidden="true">
        <div className={styles.detailSkeletonCover} />
        <div className={styles.detailSkeletonInfo}>
          <div className={styles.skeletonHeading} />
          <div className={styles.skeletonLineShort} />
          <div className={styles.skeletonPills}>
            <span className={styles.skeletonPill} />
            <span className={styles.skeletonPill} />
            <span className={styles.skeletonPill} />
          </div>
          <div className={styles.skeletonParagraph} />
        </div>
      </div>
      <span className="visually-hidden">Cargando ficha del anime…</span>
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className={styles.center} role="alert">
      <p>{message}</p>
      {onRetry && (
        <button className="btn btn--ghost" onClick={onRetry}>
          Reintentar
        </button>
      )}
    </div>
  );
}

export function EmptyState({ message, actionLabel, onAction }: { message: string; actionLabel?: string; onAction?: () => void }) {
  return (
    <div className={styles.center}>
      <p className="muted">{message}</p>
      {actionLabel && onAction && (
        <button className="btn btn--ghost" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : "Algo salió mal";
}
